<template>
  <b-row>
    <b-col cols="12" xl="12">
      <person-search-form
        @change="onSearchResult"
        @click="onSearchClick"
        :pagination="pagination"
      ></person-search-form>
    </b-col>
    <b-col cols="12" xl="6">
      <transition name="slide">
        <b-card>
          <div slot="header">
            <strong>People</strong>
          </div>
          <pagination-table
            :items="people"
            :pagination="pagination"
            :fields="[
              {key: 'name'},
              {key: 'surname'},
              {key: 'email'},
              {key: 'type'},
              {key: 'actions'},
            ]"
            :is-loading="isLoading"
            @change="onPaginationChange"
            item-url="people/{id}"
          ></pagination-table>
        </b-card>
      </transition>
    </b-col>
    <b-col cols="12" xl="6">
      <flash-message transitionIn="animated swing"></flash-message>
      <b-card>
        <div slot="header">
          <strong>Person</strong>
        </div>
        <person-form :add-option="true"></person-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
  import {PaginationMeta} from "../../models/PaginationMeta";
  import PersonForm from "../../components/person/PersonForm";
  import PersonSearchForm from "../../components/person/PersonSearchForm";
  import PaginationTable from "../../components/base/PaginationTable";

  const PeopleRepo = RepositoryFactory.get('people')

  export default {
      name: 'people',
      components: {
        PaginationTable,
        PersonSearchForm,
        PersonForm
      },
      data: () => {
        return {
            people: [],
            pagination: new PaginationMeta(),
            isLoading: true,
            searchParams: {},
        }
      },
      created () {
        PeopleRepo
              .get()
              .then(
                  response => (
                      this.people = response.data.data,
                      this.pagination = response.data.meta,
                      this.isLoading = false
                  )
              )
      },
      methods: {
          onSearchResult(response) {
              this.people = response.data,
              this.pagination = response.meta
              this.isLoading = false
          },
          onSearchClick(params) {
              this.isLoading = true
              this.searchParams = params
          },
          onPaginationChange(){
              this.searchParams.page = this.pagination.page;
              this.searchParams.limit = this.pagination.limit;

              PeopleRepo
                .searchPeople(this.searchParams)
                .then(
                  response => (
                      this.items = response.data.data,
                      this.pagination = response.data.meta,
                      this.isLoading = false
                  )
                )
          },
      }
  }
</script>
